import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@walmart-web/livingdesign-components';

function ShimmerCB() {
	const useStyles = makeStyles(() => ({
		chartContainer: {
			padding: '12px 16px 20.5px',
			marginTop: '1px',
			borderRadius: '8px',
		},
		metric: {
			margin: '16.5px 0 15.5px',
		},
		loadingTabContainer: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'flex-start',
			gap: '16px',
			marginBottom: '10px',
		},

		loadingTabValue: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'flex-start',
			gap: '16px',
		},
		loadingChartGridLine: {
			borderBottom: '1px #e6e6e6 solid',
			marginTop: '13px',
		},
		chartTab: {
			display: 'flex',
			justifyContent: 'center',
			gap: '16px',
			marginTop: '18px',
		},
		loadingLegend: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'center',
			alignItems: 'center',
			gap: '28px',
			marginTop: '30px',
		},

		loadingLegendItem: {
			display: 'flex',
			flexDirection: 'row',
			gap: '8px',
		},
		row: {
			marginTop: '20px',
			display: 'flex',
			gap: '2px',
			justifyContent: 'space-around',
		},
		rowBorder: {
			borderLeft: '1px #e6e6e6 solid',
		},
		rowGap: {
			marginTop: '2px',
		},
	}));

	const classes = useStyles();

	return (
		<>
			<div className={classes.chartContainer}>
				{/* metric name */}
				<div className={classes.metric}>
					<Skeleton height="17.5px" width="129px" variant="rounded" />
				</div>

				{/* Tabs */}
				<div className={classes.loadingTabContainer}>
					<Skeleton height="12px" width="49px" variant="rounded" />
					<Skeleton height="12px" width="49px" variant="rounded" />
				</div>

				<div className={classes.loadingTabValue}>
					<Skeleton height="12px" width="71px" variant="rounded" />
					<Skeleton height="12px" width="71px" variant="rounded" />
				</div>
				{/* Line */}
				<div className={classes.loadingChartGridLine}></div>

				{/* Chart */}

				<div className={classes.chartTab}>
					<Skeleton height="12px" width="76px" variant="rounded" />
					<Skeleton height="12px" width="58px" variant="rounded" />
					<Skeleton height="12px" width="58px" variant="rounded" />
				</div>

				{/* chart row */}

				<div className={classes.row}>
					<Skeleton height="8px" width="61px" variant="rounded" />
					<Skeleton height="8px" width="24px" variant="rounded" />
					<Skeleton height="8px" width="24px" variant="rounded" />
					<Skeleton height="8px" width="24px" variant="rounded" />

					<div className={classes.rowBorder}>
						<Skeleton height="10px" width="191px" variant="rectangle" />
						<div className={classes.rowGap}>
							<Skeleton height="10px" width="161px" variant="rectangle" />
						</div>
					</div>
				</div>

				<div className={classes.row}>
					<Skeleton height="8px" width="61px" variant="rounded" />
					<Skeleton height="8px" width="24px" variant="rounded" />
					<Skeleton height="8px" width="24px" variant="rounded" />
					<Skeleton height="8px" width="24px" variant="rounded" />

					<div className={classes.rowBorder}>
						<Skeleton height="10px" width="191px" variant="rectangle" />
						<div className={classes.rowGap}>
							<Skeleton height="10px" width="171px" variant="rectangle" />
						</div>
					</div>
				</div>

				<div className={classes.row}>
					<Skeleton height="8px" width="61px" variant="rounded" />
					<Skeleton height="8px" width="24px" variant="rounded" />
					<Skeleton height="8px" width="24px" variant="rounded" />
					<Skeleton height="8px" width="24px" variant="rounded" />

					<div className={classes.rowBorder}>
						<Skeleton height="10px" width="191px" variant="rectangle" />
						<div className={classes.rowGap}>
							<Skeleton height="10px" width="181px" variant="rectangle" />
						</div>
					</div>
				</div>

				<div className={classes.row}>
					<Skeleton height="8px" width="61px" variant="rounded" />
					<Skeleton height="8px" width="24px" variant="rounded" />
					<Skeleton height="8px" width="24px" variant="rounded" />
					<Skeleton height="8px" width="24px" variant="rounded" />

					<div className={classes.rowBorder}>
						<Skeleton height="10px" width="191px" variant="rectangle" />
						<div className={classes.rowGap}>
							<Skeleton height="10px" width="140px" variant="rectangle" />
						</div>
					</div>
				</div>

				<div className={classes.row}>
					<Skeleton height="8px" width="61px" variant="rounded" />
					<Skeleton height="8px" width="24px" variant="rounded" />
					<Skeleton height="8px" width="24px" variant="rounded" />
					<Skeleton height="8px" width="24px" variant="rounded" />

					<div className={classes.rowBorder}>
						<Skeleton height="10px" width="191px" variant="rectangle" />
						<div className={classes.rowGap}>
							<Skeleton height="10px" width="150px" variant="rectangle" />
						</div>
					</div>
				</div>

				{/* Legends */}

				<div className={classes.loadingLegend}>
					<div className={classes.loadingLegendItem}>
						<Skeleton height="8px" width="24px" variant="rectangle" />
						<Skeleton height="10.5px" width="36px" variant="rounded" />
					</div>

					<div className={classes.loadingLegendItem}>
						<Skeleton height="8px" width="24px" variant="rectangle" />
						<Skeleton height="10.5px" width="73px" variant="rounded" />
					</div>
				</div>
			</div>
		</>
	);
}

export default ShimmerCB;
